import { jsx as _jsx } from "react/jsx-runtime";
import { HourlyYearBasedNormalAccumulator } from '@iotv/datamodel-core';
import { AccumulatorClasses } from '@iotv/iotv-v3-types';
import { useEffect, useMemo, useState } from 'react';
import { getDehydratedAccumulator } from '../../../data/aws/s3/AccumulationPeriodization';
import { ObjectDataAccumulationCard } from '../../generic/ObjectDataAccumulationCard';
/**
 * # DO NOT USE
 *
 * This component _only_ exists for viewing and analysis in the `WIDGET_PLAYGROUND`
 */
export const ObjectDataAccumulationCardWidget = (props) => {
    const [accumulator, setAccumulator] = useState(undefined);
    const [accumulatorError, setAccumulatorError] = useState(undefined);
    useEffect(() => {
        if (props.contextCustomer)
            getDehydratedAccumulator(props.contextCustomer, AccumulatorClasses.HourlyYearBasedNormalAccumulator).then(({ err, data }) => {
                if (err || !data) {
                    setAccumulatorError(err?.message ?? 'No data');
                }
                if (data) {
                    const accumulator = new HourlyYearBasedNormalAccumulator();
                    accumulator.ingest(data);
                    setAccumulator(accumulator);
                }
            });
    }, [props.contextCustomer?.sk]);
    const component = useMemo(() => _jsx(ObjectDataAccumulationCard, { accumulator: accumulator, error: accumulatorError }), [accumulator, accumulatorError]);
    return {
        name: 'ObjectDataAccumulationCard',
        category: 'generic',
        component,
    };
};
